// <s-gallery-dots> mirrors the mobile product gallery's scroll position as dots; a dot scrolls to its image.
// The gallery is the sibling [data-product-gallery] inside the same parent. Hidden on md+ where the gallery is a grid.
class GalleryDots extends HTMLElement {
  #gallery = null;
  #dots = [];
  #controller = null;

  connectedCallback() {
    this.#gallery = this.parentElement?.querySelector('[data-product-gallery]');
    this.#dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
    if (!this.#gallery || this.#dots.length < 2) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#gallery.addEventListener('scroll', () => this.#sync(), { signal, passive: true });
    this.#dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = this.#gallery.children[index];
        if (!slide) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#gallery.scrollTo({ left: slide.offsetLeft - this.#gallery.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }, { signal });
    });
    this.#sync();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #sync() {
    const width = this.#gallery.clientWidth || 1;
    const index = Math.round(Math.abs(this.#gallery.scrollLeft) / width);
    this.#dots.forEach((dot, i) => {
      dot.setAttribute('aria-current', String(i === index));
    });
  }
}

if (!customElements.get('s-gallery-dots')) customElements.define('s-gallery-dots', GalleryDots);
